import { forwardRef, type InputHTMLAttributes } from 'react';
import { cn } from '../lib/cn.js';

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  hasError?: boolean;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ className, hasError, ...rest }, ref) => (
    <input
      ref={ref}
      className={cn(
        'h-14 w-full rounded-[1.125rem] border bg-surface px-4 text-[15px] text-text shadow-[0_8px_24px_hsl(var(--color-text)/0.04)] placeholder:text-text-muted/80 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/35 disabled:cursor-not-allowed disabled:opacity-50',
        hasError ? 'border-danger' : 'border-border',
        className,
      )}
      {...rest}
    />
  ),
);
Input.displayName = 'Input';
